import OperandTypes from '../../constants/behavior_operand_types';
import OperatorFunctions from './operator_functions'
import OperatorFunctionsDate from './operator_functions_date'
import FieldsOperandParser, { parseDate , parseTextArea , convertUndefinedValueToEmpty } from './field/fields_operand_parser'
import ScriptParser from '../script/script_parser';
import { getFieldAPI } from '../../utils/form_element_api_builder';

export const parse = (formAPI, operand, fieldAPI) => {	
	switch(operand.type) {
		case OperandTypes.EXPRESSION:
			return parseExpressionOperand(formAPI, operand);
		case OperandTypes.FIELD:
			return parseFieldOperand(formAPI, operand);
		case OperandTypes.SCRIPT:
			return evalParsedScriptOperand(formAPI, operand);
		case OperandTypes.VALUE_FORM_SUBMIT:
			return parseValueSubmitForm(operand);
		case OperandTypes.OPERATION_GRID:
			return parseOperandGrid(formAPI, operand);
		case OperandTypes.VALUE:
		default:
			if (fieldAPI && fieldAPI.type() === 'DATE') {
				return parseDate(operand.value);
			}
			if (fieldAPI && fieldAPI.type() === 'TEXTAREA') {
				return parseTextArea(operand.value);
			}
			return convertUndefinedValueToEmpty(operand.value);
	}
};

const parseExpressionOperand = (formAPI, expression) => {
	const leftOperand = parse(formAPI, expression.leftOperand);
	let rightOperand = parse(formAPI, expression.rightOperand, getFieldAPI(formAPI, expression.leftOperand));

	const field =  getFieldAPI(formAPI, expression.leftOperand);
	let fieldOptions;

	const { operator } = expression;

	try {
		if(field.type() === 'AUTOCOMPLETE' || field.type() === 'RADIO'){
			fieldOptions = field.options();
		}

		if(operator === 'CONTAINS_ERROR' || operator === 'NOT_CONTAINS_ERROR'){
			if(field.containsError && field.containsError() === true){
				rightOperand = true;

				if(field && field.type && field.type() === 'DATE') {
					return operateDATE(leftOperand, rightOperand, operator, fieldOptions, field);
				}

				return operate(leftOperand, rightOperand, operator, fieldOptions);
			}
			else {
				rightOperand = false;

				if(field && field.type && field.type() === 'DATE') {
					return operateDATE(leftOperand, rightOperand, operator, fieldOptions, field);
				}

				return operate(leftOperand, rightOperand, operator, fieldOptions);
			}
		}

		if(field && field.type && field.type() === 'DATE') {
			return operateDATE(leftOperand, rightOperand, operator, fieldOptions);
		}

		return operate(leftOperand, rightOperand, operator, fieldOptions);
	}
	catch(err) {

		if(field && field.type && field.type() === 'DATE') {
			return operateDATE(leftOperand, rightOperand, operator, fieldOptions, field);
		}

		return operate(leftOperand, rightOperand, operator, fieldOptions);
	}
};

const parseFieldOperand = (formAPI, fieldOperand) => {
	const fieldAPI = getFieldAPI(formAPI, fieldOperand);
	const property = fieldOperand.property || 'value';

	return FieldsOperandParser.parse(fieldAPI, property);
};

const evalParsedScriptOperand = (formAPI, scriptOperand) => {
	const parsedScript = ScriptParser.parse(formAPI, scriptOperand.value);
	const arr = parsedScript.split('+');
	let valueN = '', valueScript = '', countS = 0;

	arr.forEach((val, key) => {
		if(!isNaN(val)){
			(key === 0) ? valueN += val : valueN += '+' + val;
		}else if(val.replace(/'/g, '') !== "") {
			countS++;
		}
	});

	if(valueN.trim() != '' && countS === 0){
		valueScript = parseFloat(eval(valueN));
	}else{
		try{
			valueScript = eval(parsedScript);
		}catch(e){
			arr.forEach((val)=>{
				valueScript += val.replace(/'/g, '');
			});
		}
	}

	return valueScript !== undefined && valueScript !== null ? valueScript : "";
};

const parseValueSubmitForm = (operand) => {
	const parsedValue = {};
	parsedValue.value = operand.value;
	parsedValue.formActionName = operand.formActionName;
	return parsedValue;
}

const operateDATE = (leftOperand, rightOperand, operator, fieldOptions, field) => {
	const operatorFunction = OperatorFunctionsDate[operator];
	return operatorFunction(leftOperand, rightOperand, fieldOptions, field);
};

const operate = (leftOperand, rightOperand, operator, fieldOptions) => {
	const operatorFunction = OperatorFunctions[operator];
	return operatorFunction(leftOperand, rightOperand, fieldOptions);
};

const parseOperandGrid = (formAPI, scriptOperand) => {	
	const gridField = formAPI.fields(scriptOperand.gridId).fields(scriptOperand.gridFieldId);		
	return formAPI.fields(scriptOperand.gridId).operation(scriptOperand.value, gridField.id);	
};

export default {
	parse,
};
